// extracted by mini-css-extract-plugin
export var divider = "_o1-0";
export var systemMessage = "_o1-1";